// extracted by mini-css-extract-plugin
export default {"container":"nhl-game-end_container__2JTWb","card":"nhl-game-end_card__2BNwg","inner":"nhl-game-end_inner__3rCgD","questionsList":"nhl-game-end_questionsList__32V0L"};